import { useEffect, useState } from "react";
import Button from "../../Custom/Button/Button";
import "./mailUpdate.css";
import axios from "axios";
import { useGlobalContext } from "../../../Context/Context";

const MailUpdate = ({
  usersData,
  setUsersData,
  userUpdate,
  setUpdated,
  checkBack,
  setCheckBack,
  custom,
  setCustom,
  selectedCompany,
  setMail,
  selected,
  currentTab,
  updatedAddress,
  setUpdatedAddress,
}) => {
  const { baseUrl } = useGlobalContext();
  const { loggedUser, apiKey } = useGlobalContext();

  const handleUpdate = (e) => {
    setUpdatedAddress({ ...updatedAddress, [e.target.name]: e.target.value });
  };

  const castingObject = (cond) => {
    console.log(selectedCompany);
    if (cond) {
      // AZURIRANJE
      switch (custom.name) {
        case "Adresar": {
          return {
            data: {
              user_id: loggedUser.id,
              company_id: selectedCompany.company_id,
              api_key: apiKey,
              ab_name: updatedAddress.name,
              ab_email: updatedAddress.email,
              address_book_id: updatedAddress.id,
            },
            url: `${baseUrl}/admin_panel/address_book/update.php`,
          };
        }
        case "Imenik": {
          return {
            data: {
              user_id: loggedUser.id,
              api_key: apiKey,
              company_id: selectedCompany.company_id,
              pb_name: updatedAddress.name,
              pb_number: updatedAddress.data,
              phonebook_id: updatedAddress.id,
            },
            url: `${baseUrl}/admin_panel/phonebook/update.php`,
          };
        }
        case "Mesta": {
          return {
            data: {
              user_id: loggedUser.id,
              company_id: selectedCompany.company_id,
              api_key: apiKey,
              company_place_name: updatedAddress.name,
              company_place_address: updatedAddress.address,
              company_place_city: updatedAddress.town,
              company_place_id: parseInt(updatedAddress.id),
            },
            url: `${baseUrl}/admin_panel/company_places/update.php`,
          };
        }
        default: {
        }
      }
    } else {
      // DODAVANJE
      switch (custom.name) {
        case "Adresar": {
          return {
            data: {
              user_id: loggedUser.id,
              api_key: apiKey,
              ab_name: updatedAddress.name,
              ab_email: updatedAddress.email,
              company_id: selectedCompany.company_id,
            },
            url: `${baseUrl}/admin_panel/address_book/create.php`,
          };
        }
        case "Imenik": {
          return {
            data: {
              user_id: loggedUser.id,
              api_key: apiKey,
              pb_name: updatedAddress.name,
              pb_number: updatedAddress.data,
              company_id: selectedCompany.company_id,
            },
            url: `${baseUrl}/admin_panel/phonebook/create.php`,
          };
        }
        case "Mesta": {
          return {
            data: {
              user_id: loggedUser.id,
              api_key: apiKey,
              company_place_name: updatedAddress.name,
              company_place_address: updatedAddress.address,
              company_place_city: updatedAddress.town,
              company_id: selectedCompany.company_id,
            },
            url: `${baseUrl}/admin_panel/company_places/create.php`,
          };
        }
        default: {
        }
      }
    }
  };

  const handleAdd = async () => {
    const newObject = castingObject(userUpdate.value);

    let isSomethingEmpty = false;
    Object.values(newObject.data).forEach((object) => {
      if (object === "") isSomethingEmpty = true;
    });
    if (isSomethingEmpty) {
      console.log("Ne smete imati praznih polja!");
      return;
    }
    if (userUpdate.value) {
      // azuriranje
      try {
        const response = await axios.put(newObject.url, newObject.data);
        const { data } = response;
        console.log(data);
        console.log(custom);
        console.log(updatedAddress);
        if (data.status === 200) {
          const newData = custom.data.map((data) => {
            if (data.id === updatedAddress.id) {
              return updatedAddress;
            } else {
              return data;
            }
          });
          setCustom({ ...custom, data: newData });
        }
      } catch (error) {
        if (error?.response.status === 401) {
          console.log("Ima praznih polja");
        }
        console.log(error);
      }
    } else {
      // dodavanje
      try {
        const response = await axios.post(newObject.url, newObject.data);

        const { data } = response;
        console.log(data);
        console.log(custom);
        console.log(updatedAddress);
        if (data.status === 200) {
          const sendData = { ...updatedAddress, id: data.id };
          const newData = [...custom.data, sendData];
          setCustom({ ...custom, data: newData });
        }
      } catch (error) {
        if (error.response?.status === 401) {
          console.log("Ima praznih polja");
        }

        console.log(error);
      }
    }
    setCheckBack(false);
    setUpdated({
      value: false,
      user: {},
    });
  };

  return (
    <div className="wrapper-mail-change">
      {userUpdate.user !== undefined ? (
        <h3>{`Izmeni ${custom.titleChange}`}</h3>
      ) : (
        <h3>{`Dodaj ${custom.titleChange}`}</h3>
      )}
      <div className="mail-input-form">
        {updatedAddress !== null &&
          Object.keys(custom.properties).map((value, index) => {
            if (value === "id") return null;
            return (
              <>
                <label htmlFor={value}>{custom.titles[index]}</label>
                <input
                  id={value}
                  name={value}
                  value={updatedAddress[`${value}`]}
                  onChange={handleUpdate}
                />
              </>
            );
          })}
      </div>
      <div className="mail-change-btn" onClick={handleAdd}>
        <Button activation={true}>POTVRDI</Button>
      </div>
    </div>
  );
};

export default MailUpdate;
